import axios from 'axios'

const BASE_URI = process.env.NODE_ENV === 'development' ? 'http://192.168.28.7' : ''

axios.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '')

    if (user != '' && user.token) {
      config.headers['Authorization'] = `Bearer ${user.token}`
    }

    return config
  } catch (error) {
    return config
  }
})

export const POST = (url: string, payload: any, headers?: any) => {
  return axios.post(`${BASE_URI}${url}`, payload, { headers })
}

export const GET = (url: string, options?: any) => {
  return axios.get(`${BASE_URI}${url}`, options)
}

export const DOWNLOAD = (url: string) => `${BASE_URI}${url}`
